// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__HsJXF","inner":"styles_inner__3IuGO","right":"styles_right__3Kxjl","close":"styles_close__y5qJV","footer":"styles_footer__foDnO"};